import Swal from "./sweetalert2";

export default window.bootstrapvalidation = function bootstrapvalidation() {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.getElementsByClassName("needs-validation");
    // Loop over them and prevent submission
    var validation = Array.prototype.filter.call(forms, function (form) {
        form.addEventListener(
            "submit",
            function (event) {
                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();

                    var errorElements = document.querySelectorAll(
                        "input.filepond--browser:invalid, input.form-control:invalid, select.form-control:invalid, textarea.form-control:invalid"
                    );
                    var alertformdata = [];
                    var erroretesto = `${translation["javascript-attenzione-campi-mancanti"]}`;

                    var firsterror = $(errorElements[0]);
                    var showswal = false;
                    errorElements.forEach(function (element) {
                        var jelement = $(element);

                        if (jelement.hasClass("filepond--browser")) {
                            var labeltext = jelement
                                .parent()
                                .parent()
                                .children("label")
                                .text();
                        } else {
                            var labeltext = jelement
                                .parent()
                                .find("label")
                                .text();
                        }
                        if (labeltext != "") {
                            alertformdata.push(labeltext);
                            erroretesto += `<small class="fs-16"><br/>${labeltext}</small>`;
                            showswal = true;
                            /*element.parentNode.childNodes.forEach(function (node) {
                            if (node.className == "valid-feedback") {
                                node.className = "invalid-feedback";
                                node.innerText = "Please choose a Gender";
                            }
                        });
                        */
                        }
                    });

                    if ($(form).hasClass("dotheswal")) {
                        if (showswal) {
                            Swal.fire({
                                showCancelButton: false,
                                icon: "warning",
                                html: `<span class="fs-25">${erroretesto}</div>`,
                                title: "",
                            });
                        }
                    }
                }
                form.classList.add("was-validated");
            },
            false
        );
    });
};

(function () {
    "use strict";
    window.addEventListener(
        "load",
        function () {
            bootstrapvalidation();
        },
        false
    );
})();
